import React, { useState } from "react";
import { FaRegClock } from "react-icons/fa";
import { MdRemoveCircleOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import ConformationModal from "./ConformationModal";

/**
 * Compact course card for cluster "Manage Courses" tab (matches legacy admin/courses card layout).
 */
const ManageClusterCourseCard = ({
  name,
  short_description,
  time_period,
  course_id,
  onRemove,
  isSuperAdmin,
  /** Cluster tab: detach is allowed without global super-admin (still requires parent to pass handler). */
  allowClusterDetach = false,
  level,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [courseToDelete, setCourseToDelete] = useState(null);
  const [showFullDescription, setShowFullDescription] = useState(false);

  const desc = typeof short_description === "string" ? short_description : "";

  const handleDeleteClick = (id) => {
    setCourseToDelete(id);
    setOpenModal(true);
  };

  const handleConfirmDelete = () => {
    if (onRemove && courseToDelete) {
      onRemove(courseToDelete);
    }
    setOpenModal(false);
    setCourseToDelete(null);
  };

  const toggleDescription = (e) => {
    e.preventDefault();
    setShowFullDescription(!showFullDescription);
  };

  return (
    <div className="group relative transition-transform duration-300 ease-in-out hover:scale-105">
      {((isSuperAdmin || allowClusterDetach) && onRemove) && (
        <MdRemoveCircleOutline
          onClick={() => handleDeleteClick(course_id)}
          aria-label="Delete course"
          className="absolute top-2 right-2 z-10 h-6 w-6 cursor-pointer text-gray-500 hover:text-red-500"
        />
      )}

      <Link
        to={`/admin/courses/${course_id}`}
        className={`flex min-h-[300px] w-[300px] flex-col justify-between rounded-lg bg-white shadow-xl ${
          !onRemove
            ? "cursor-pointer transition ease-in-out hover:-translate-y-1 hover:scale-105"
            : ""
        }`}
      >
        <div className="p-6">
          <div className="mb-2 text-xl font-bold text-gray-800 transition group-hover:text-blue-600">
            {name}
          </div>
          <div className={`text-sm text-slate-500 ${showFullDescription ? "" : "line-clamp-5"}`}>
            {desc}
          </div>
          {desc.length > 150 && (
            <span
              onClick={toggleDescription}
              className="mt-2 inline-block cursor-pointer text-sm text-blue-600"
            >
              {showFullDescription ? "Read less" : "Read more"}
            </span>
          )}
        </div>

        {time_period && (
          <div className="flex items-center justify-between px-6 pb-6 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <FaRegClock className="text-blue-500" />
              {time_period} hrs
            </div>
            {level ? (
              <div className="rounded-full bg-blue-100 px-2 py-1 text-xs text-blue-600">
                {level}
              </div>
            ) : null}
          </div>
        )}
      </Link>

      {courseToDelete && (
        <ConformationModal
          openModal={openModal}
          event={handleConfirmDelete}
          setOpenModal={setOpenModal}
          text={"Are you sure you want to delete this course?"}
        />
      )}
    </div>
  );
};

export default ManageClusterCourseCard;
